import type { CheatRow, CombatBlock } from '@/features/playbook/types';

export const cheatRows: CheatRow[] = [
  {
    label: 'Concentration (scriptorium focus)',
    formula: 'Sta 1 + Concentration 4 = 5',
    note: 'Resist distraction while copying manuscripts; +1 with reading specialty.',
  },
  {
    label: 'Etiquette (court)',
    formula: 'Pre 1 + Etiquette 3 = 4',
    note: 'Navigate court protocol; switch to Com 2 + 3 = 5 for social grace variants.',
  },
  {
    label: 'Bargain (book acquisitions)',
    formula: 'Com 2 + Bargain 3 = 5',
    note: 'Haggle over manuscript prices or trade terms with Books specialty.',
  },
  {
    label: 'Latin (academic texts)',
    formula: 'Int 2 + Latin 4 = 6',
    note: 'Read and interpret scholarly writing; +1 with Academic Usage specialty.',
  },
  {
    label: 'Awareness (searching)',
    formula: 'Per 1 + Awareness 2 = 3',
    note: 'Notice details during search or inspection; +1 searching specialty.',
  },
  {
    label: 'French (native, under pressure)',
    formula: 'Com 2 + French 5 = 7 + die',
    note: 'Speak fluently or persuade in French; rolled when stakes rise.',
  },
];

export const combatBlock: CombatBlock = {
  init: 'Qik 0 + Init 0 = 0',
  attack: 'Dex -1 + Brawl 0 + Knife (atk 0) = -1',
  defense: 'Qik 0 + Brawl 0 + Knife (def 0) = 0',
  damage: 'Str -1 + Knife +2 = +1',
  soak: 'Sta 1 + Armor 0 = 1',
  notes: 'Untrained in Brawl; with Brave -3 and Short of Breath flaws, she avoids combat and shelters behind trained grogs. Note: knife here is Brawl-class, not Single Weapon.',
};
